/* eslint-disable max-len */
import React from "react";

import type { CheckboxSize } from ".";

import styles from "./NoteCheckbox.module.css";

export default function CircleCheckbox({ size }: { size: CheckboxSize }) {
	switch (size) {
		case "large":
			return (
				<svg
					className={styles.checkboxSvg}
					width="19"
					height="19"
					viewBox="0 0 19 19"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						className={styles.checkmark}
						fillRule="evenodd"
						clipRule="evenodd"
						d="M14.3185 5.95496C14.6747 6.30158 14.6825 6.87138 14.3359 7.22763L8.29906 13.4322C7.95673 13.784 7.39561 13.7966 7.03781 13.4605L4.48376 11.0614C4.12147 10.721 4.10366 10.1515 4.44398 9.78918C4.7843 9.4269 5.35387 9.40909 5.71615 9.7494L7.62565 11.5431L13.0458 5.97239C13.3924 5.61614 13.9622 5.60833 14.3185 5.95496Z"
						fill="var(--vividRoyal)"
					/>
					<circle className={styles.box} cx="9.5" cy="9.5" r="8.75" stroke="var(--vividRoyal)" strokeWidth="1.5" />
					<circle className={styles.background} cx="9.5" cy="9.5" r="8" fill="var(--vividRoyal)" />
				</svg>
			);
		case "medium":
			return (
				<svg
					className={styles.checkboxSvg}
					width="14"
					height="14"
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						className={styles.checkmark}
						fillRule="evenodd"
						clipRule="evenodd"
						d="M10.1694 4.57793C10.4168 4.81864 10.4222 5.21433 10.1815 5.46173L6.33986 9.41007C6.10214 9.65441 5.71246 9.66317 5.464 9.42976L3.83869 7.90301C3.5871 7.66668 3.57474 7.27115 3.81107 7.01956C4.0474 6.76797 4.44293 6.75561 4.69452 6.99194L5.87222 8.09822L9.28559 4.59003C9.5263 4.34263 9.92199 4.33721 10.1694 4.57793Z"
						fill="var(--vividRoyal)"
					/>
					<circle className={styles.box} cx="7" cy="7" r="6.375" stroke="var(--vividRoyal)" strokeWidth="1.25" />
					<circle className={styles.background} cx="7" cy="7" r="5.75" fill="var(--vividRoyal)" />
				</svg>
			);
		case "small":
			return (
				<svg
					className={styles.checkboxSvg}
					width="12"
					height="12"
					viewBox="0 0 12 12"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						className={styles.checkmark}
						fillRule="evenodd"
						clipRule="evenodd"
						d="M8.71659 3.92391C8.92864 4.13023 8.93329 4.4694 8.72696 4.68145L5.43413 8.06575C5.23037 8.27518 4.89636 8.28269 4.68339 8.08263L3.29027 6.77399C3.07462 6.57142 3.06402 6.23239 3.26659 6.01674C3.46916 5.8011 3.80819 5.79049 4.02384 5.99306L5.03329 6.94131L7.95904 3.93429C8.16537 3.72223 8.50453 3.71759 8.71659 3.92391Z"
						fill="var(--vividRoyal)"
					/>
					<circle className={styles.box} cx="6" cy="6" r="5.375" stroke="var(--vividRoyal)" strokeWidth="1.25" />
					<circle className={styles.background} cx="6" cy="6" r="4.75" fill="var(--vividRoyal)" />
				</svg>
			);
	}
}
